const options = {
  5: "bg-emerald-50/5",
  10: "bg-emerald-50/10",
  25: "bg-emerald-50/25",
  50: "bg-emerald-50/50",
  75: "bg-emerald-50/75",
  90: "bg-emerald-50/90",
  100: "bg-emerald-50",
};

const from = {
  5: "from-emerald-50/5",
  10: "from-emerald-50/10",
  25: "from-emerald-50/25",
  50: "from-emerald-50/50",
  75: "from-emerald-50/75",
  90: "from-emerald-50/90",
  100: "from-emerald-50",
};

export default function getBackgroundEmerald50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
